interface MoustacheLogoProps {
  width: number;
  height: number;
}

const MoustacheLogo = ({ width, height }: MoustacheLogoProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 88 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84.93 3.91004C84.93 3.91004 89.32 13.84 81.06 15.81C72.8 17.78 69.06 11.89 69.06 11.89C69.06 11.89 62.68 2.06003 54.06 1.43003C45.44 0.80003 44.16 7.01003 44.16 7.01003V6.84003C44.16 6.84003 43.05 0.590038 34.4 1.00004C25.75 1.41004 19.13 11.06 19.13 11.06C19.13 11.06 15.2 16.86 6.98998 14.67C-1.22002 12.48 3.42999 2.67004 3.42999 2.67004C3.42999 2.67004 -2.65 10 3.63 17.49C9.91 24.98 27.73 24.04 27.73 24.04C27.73 24.04 42.22 23.04 44.06 14.25V14.42C45.67 23.27 60.14 24.63 60.14 24.63C60.14 24.63 77.92 26.03 84.39 18.71C90.86 11.39 84.93 3.91004 84.93 3.91004Z"
      fill="#FF8C00"
    />
  </svg>
);

export default MoustacheLogo;
